import React, { useEffect, useState } from 'react';
import Seating from '../../assets/images/requests/Seating.jpg';
import Table from '../../assets/images/requests/Table.png';
import Storage from '../../assets/images/requests/Storage.jpg';
import Rugs from '../../assets/images/requests/Rugs.jpg';
import Lighting from '../../assets/images/requests/Lighting.jpg';
import Mattresses from '../../assets/images/requests/Mattresses.jpg';
import Bed from '../../assets/images/requests/Bed.jpg';
import Other from '../../assets/images/requests/Other.jpg';
import {
  requestsSelector,
  setCurrentRequestCategory,
  setNextButtonEnabled,
  setNextButtonToolTip,
} from '../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import Wrapper from '../../screens/Requests/Sections/Wrapper';
import RequestThumbnailCardUI from '../../screens/Requests/Sections/RequestThumbnailCardUI';
import { apiGetRequestProductCategoreis, apiUpdateRequest } from '../../helpers/api';
import { useRef } from 'react';
import { useFilterList } from '../../hooks/useFilterList';
import { useUserContext } from '../../contexts/UserContext';

const SelectCategory = () => {
  const { isGuestUser } = useUserContext();
  const _requestSelector = useSelector(requestsSelector);
  const [selected, setSelected] = useState(_requestSelector.currentRequestCategory);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const dataRef = useRef();

  const list = [
    {
      id: 1,
      name: 'Seating',
      thumbnail: Seating,
    },
    {
      id: 2,
      name: 'Table',
      thumbnail: Table,
    },
    {
      id: 3,
      name: 'Storage',
      thumbnail: Storage,
    },
    {
      id: 4,
      name: 'Rugs & Carpets',
      thumbnail: Rugs,
    },
    {
      id: 5,
      name: 'Lighting',
      thumbnail: Lighting,
    },
    {
      id: 6,
      name: 'Mattresses',
      thumbnail: Mattresses,
    },
    {
      id: 7,
      name: 'Bed Frames',
      thumbnail: Bed,
    },
    {
      id: 8,
      name: 'Other',
      thumbnail: Other,
    },
  ];

  const data = useFilterList({ type: 4 });

  const handleClick = async ({ id }) => {
    if (id) {
      dispatch(setNextButtonEnabled(true));
      dispatch(setNextButtonToolTip(null))
      const formData = new FormData();
      formData.append('category_name', list.find((_item) => _item.id === id)?.name);

      if(isGuestUser()) {
        formData.append('is_internal_team', true);
      }

      await apiUpdateRequest(_requestSelector.currentRequestId, formData);
    } else {
      dispatch(setNextButtonEnabled(false));
      dispatch(setNextButtonToolTip("Please select a category first."))
    }

    dataRef.current = id;
    setSelected(id);
    dispatch(setCurrentRequestCategory(id));
  };

  useEffect(async () => {
    return async () => {
      if (dataRef.current) {
        const formData = new FormData();
        formData.append('filter_options', dataRef.current);

        if(isGuestUser()) {
          formData.append('is_internal_team', true);
        }

        await apiUpdateRequest(_requestSelector.currentRequestId, formData);
      }
    };
  }, []);

  return (
    <>
      <Wrapper title="What kind of 3D Model do you need?">
        <RequestThumbnailCardUI
          list={list}
          selected={selected}
          onCardClick={handleClick}
          size={3}
        />
      </Wrapper>
    </>
  );
};

export default SelectCategory;
